import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const FormWrapper = styled.div`
  ${media.xs`
    min-width: 100%;
  `}
  ${media.sm`
    min-width: 100%;
  `}
  ${media.md`
    min-width: 640px;
  `}
`
export const FormContainer = styled.div`
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  padding: 40px 40px 20px 40px;
  margin-bottom: 1.25rem;

  ${media.xs`
      padding: 20px;
  `}
`
export const FormFooter = styled.div`
  display: flex;
  justify-content: space-between;
`
export const FormContent = styled.div``

export const FormTitle = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0.5rem 0 2rem;
`
